(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordian-spec"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__accordianSpecScrollInit) return;
  window.__accordianSpecScrollInit = true;

  function getSpecificationsContainer(targetElement) {
    if (!targetElement) return null;
    if (targetElement.matches('[data-specifications-block]')) return targetElement;
    if (targetElement.hasAttribute('data-specifications-anchor')) {
      return targetElement.nextElementSibling;
    }
    return (
      targetElement.querySelector('[data-specifications-block]') ||
      targetElement.closest('[data-specifications-block]')
    );
  }

  function specificationsHasContent(targetId) {
    const targetElement = targetId ? document.getElementById(targetId) : null;
    const specsContainer =
      getSpecificationsContainer(targetElement) ||
      document.querySelector('[data-specifications-block]');
    return Boolean(specsContainer && specsContainer.querySelector('.specification-row'));
  }

  function syncAccordianSpecVisibility() {
    document.querySelectorAll('[data-accordian-spec-root]').forEach(function (root) {
      const details = root.querySelector('[data-accordian-spec]');
      const targetId = details ? details.getAttribute('data-accordian-spec-scroll-to') || '' : '';
      root.classList.toggle('hidden', !specificationsHasContent(targetId));
    });
  }

  function scrollToElement(targetId, behavior) {
    const targetElement = document.getElementById(targetId);
    if (!targetElement) return false;

    const scrollBuffer = 20;
    const targetPosition =
      targetElement.getBoundingClientRect().top + window.pageYOffset - scrollBuffer;

    window.scrollTo({
      top: targetPosition,
      behavior: behavior || 'smooth',
    });
    return true;
  }

  document.addEventListener('click', function (e) {
    const summary = e.target.closest('details[data-accordian-spec-scroll-to] > summary');
    if (!summary) return;

    const details = summary.closest('details');
    const targetId = details.getAttribute('data-accordian-spec-scroll-to');
    if (!targetId || !scrollToElement(targetId, 'smooth')) return;

    e.preventDefault();
  });

  function initAccordianSpec() {
    syncAccordianSpecVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordianSpec);
  } else {
    initAccordianSpec();
  }
  window.addEventListener('load', initAccordianSpec);
  document.addEventListener('shopify:section:load', initAccordianSpec);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hotspots"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__hotspotsInit) return;
  window.__hotspotsInit = true;

  function getHotspotsRoot(element) {
    return element && element.closest('[data-hotspots-image]');
  }

  function closeAllHotspots() {
    document.querySelectorAll('[data-hotspot].is-active').forEach(function (hotspot) {
      hotspot.classList.remove('is-active', 'z-[30]');
    });
    document.querySelectorAll('.hotspot-content').forEach(function (content) {
      content.classList.add('hidden');
      content.classList.remove('is-active');
      content.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-hotspots-backdrop]').forEach(function (backdrop) {
      backdrop.classList.add('hidden', 'pointer-events-none');
      backdrop.classList.remove('is-active');
      backdrop.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('.hotspot-button').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  function updateHotspotTextScrollIndicator(hotspot) {
    var scrollEl = hotspot.querySelector('[data-hotspot-text-scroll]');
    var indicator = hotspot.querySelector('[data-hotspot-text-scroll-indicator]');
    if (!scrollEl || !indicator) return;

    var hasOverflow = scrollEl.scrollHeight > scrollEl.clientHeight + 1;
    var atBottom = scrollEl.scrollTop + scrollEl.clientHeight >= scrollEl.scrollHeight - 2;

    indicator.classList.toggle('hidden', !hasOverflow || atBottom);
  }

  function bindHotspotTextScrollIndicator(hotspot) {
    var scrollEl = hotspot.querySelector('[data-hotspot-text-scroll]');
    if (!scrollEl || scrollEl.dataset.scrollIndicatorBound) return;

    scrollEl.dataset.scrollIndicatorBound = 'true';
    scrollEl.addEventListener(
      'scroll',
      function () {
        updateHotspotTextScrollIndicator(hotspot);
      },
      { passive: true }
    );

    if (typeof ResizeObserver !== 'undefined') {
      var observer = new ResizeObserver(function () {
        updateHotspotTextScrollIndicator(hotspot);
      });
      observer.observe(scrollEl);
    }
  }

  function initHotspotTextScrollIndicator(hotspot) {
    bindHotspotTextScrollIndicator(hotspot);
    requestAnimationFrame(function () {
      updateHotspotTextScrollIndicator(hotspot);
    });
  }

  function openHotspot(hotspot) {
    var root = getHotspotsRoot(hotspot);
    var content = hotspot.querySelector('.hotspot-content');
    var button = hotspot.querySelector('.hotspot-button');
    var backdrop = root && root.querySelector('[data-hotspots-backdrop]');
    if (!content || !root) return;

    closeAllHotspots();

    hotspot.classList.add('is-active', 'z-[30]');
    content.classList.remove('hidden');
    content.classList.add('is-active');
    content.setAttribute('aria-hidden', 'false');

    if (backdrop) {
      backdrop.classList.remove('hidden', 'pointer-events-none');
      backdrop.classList.add('is-active');
      backdrop.setAttribute('aria-hidden', 'false');
    }
    if (button) button.setAttribute('aria-expanded', 'true');
    initHotspotTextScrollIndicator(hotspot);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('.hotspot-content.is-active')) {
      if (event.target.closest('.hotspot-close')) {
        closeAllHotspots();
      }
      return;
    }

    if (event.target.closest('[data-hotspots-backdrop].is-active')) {
      closeAllHotspots();
      return;
    }

    var button = event.target.closest('.hotspot-button');
    if (button) {
      var hotspot = button.closest('[data-hotspot]');
      var content = hotspot && hotspot.querySelector('.hotspot-content');
      if (!hotspot || !content) return;

      var isActive = hotspot.classList.contains('is-active');
      if (isActive) {
        closeAllHotspots();
      } else {
        openHotspot(hotspot);
      }
      return;
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
